const fonts = {
    "labels": require("@frog/source/assets/images/apocalypse-tactics/ui/fonts/labels/index.js").default,
    "dialogue": require("@frog/source/assets/images/apocalypse-tactics/ui/fonts/dialogue/index.js").default,
    "numbers": require("@frog/source/assets/images/apocalypse-tactics/ui/fonts/numbers/index.js").default,
}

export default function Text(params) {
    if(params == undefined) return
    if(typeof params === "string" || params instanceof String) {
        params = {"text": params}
    }
    let string = params.text || params.string || params.value
    const font = fonts[params.font || "labels"] || fonts["labels"]
    if(string == ""
    || string == undefined) {
        return
    }
    string += ""
    return {
        "height": font.lineheight,
        "_": string.split("").map((symbol) => {
            const character = font.characters[symbol] || font.characters["unknown"]
            if(character != undefined) {
                return {
                    "margin-right": font.kerning,
                    "image": character,
                }
            }
        })
    }
}
